import { Component, OnInit } from '@angular/core';
import { Artikel } from '../models/artikel.model';
import { Lagerplatz } from '../models/lagerplatz.model';

@Component({
  selector: 'sws-infopage',
  templateUrl: './infopage.component.html',
  styleUrls: ['./infopage.component.css']
})
export class InfopageComponent implements OnInit {

  artikelListe: Artikel[];

  artikelAnz: boolean; // Merker ob Lagerplätze angezeigt werden. True = Artikelliste

  lagerplatzListe: Lagerplatz[];

  constructor() { 
    console.log("Constructor in infopage!");
    this.artikelAnz = true ;  
  }

  ngOnInit() {
    console.log("ngOnInit in infopage!");
  }

  // Event ausgelöst: Artikel wurden gelesen
  artikelGelesen(artikelSuche: Artikel[]): void {
    this.artikelListe = artikelSuche;
    console.log("Artikel sind in infopage hochgeladen!");
    console.log("Anzahl Artikel in infopage: " + artikelSuche.length.toString());
  }

// Event ausgelöst: Lagerplätze wurden gelesen
  lagerplaetzeGelesen(lpSuche: Lagerplatz[]): void {
    this.lagerplatzListe = lpSuche;
    console.log("Lagerplätze sind in infopage hochgeladen!");
    console.log("Anzahl Lagerplätze in infopage: " + lpSuche.length.toString());
  }

  // Merker ob die Artikel- oder Lagerplatzliste angezeigt wirde
  artikelListeAnz(ArtikelAnz: boolean): void {
    this.artikelAnz = ArtikelAnz;

    console.log("Anzeige Artikel oder Lagerplätze Merker: " + this.artikelAnz.toString());
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/infopage/infopage.component.ts